import { parse } from 'url';

export function getLocationOrigin() {
    const { protocol, hostname, port } = window.location;
    return `${protocol}//${hostname}${port ? ':' + port : ''}`;
}

export function isLocal(href) {
    const url = parse(href, false, true);
    const origin = parse(getLocationOrigin(), false, true);

    return !url.host || (url.protocol === origin.protocol && url.host === origin.host);
}
